import React, {createRef} from 'react'
import {findDOMNode} from 'react-dom'

import Popover from "../gd-popover/popover-v2"
import PopoverPosition from "../gd-popover/popover-position"
import {PopoverAttachmentType} from "../gd-popover/@const"
import VScroll from '../scrolling/custom-v-scroll/v-scroll'
import HintPopover from "../../gd-ui/hint-popover/hint-popover"

// @ts-ignore
import OptionInfo from '../popover-menu/popover-help-hint/popover-help-hint-depricated'

type Props = {
    className?          : string

    data                : {
        id                      : ID
        title                   : string
        icon?                   : string
        width?                  : number //required only for proper selection transition
        count?                  : number
        subItems?               : any[]
        subItemSelectedId?      : ID
        hint?                   : string
    },
    selectionIcon       : boolean
    selected            : boolean
    subItemSelectedId?  : ID
    onSelectTab         : func
}

type State = {
    showPopover         : boolean
    subItemSelectedId   : ID
}

export default class TabsOptionItem extends React.Component<Props, State> {

    private refOptionInfo: any = createRef()

    constructor(props: Props) {
        super(props)

        this.state = {
            showPopover         : false,
            subItemSelectedId   : props.subItemSelectedId ? props.subItemSelectedId : props.data.subItems ? props.data.subItems[0].id : null
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.subItemSelectedId && nextProps.subItemSelectedId !== this.props.subItemSelectedId) {
            this.setState({
                subItemSelectedId: nextProps.subItemSelectedId ? nextProps.subItemSelectedId : nextProps.data.subItems ? nextProps.data.subItems[0].id : null
            });
        }
    }

    onSelectTab = (e: React.MouseEvent) => {
        if (!!this.props.data.subItems && this.props.selected) {
            this.setState({
                showPopover: !this.state.showPopover
            });
        } else {
            this.props.onSelectTab(this.props.data.id, this.state.subItemSelectedId, e);
        }
    }

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    }

    handleHoverOn = (info: any) => {
        this.refOptionInfo.current.setMessage(info)
    }

    handleHoverOff = () => {
        this.refOptionInfo.current.setMessage(null)
    }

    onOptionClick(subItemSelectedId: ID, e: React.MouseEvent) {
        e.stopPropagation();

        this.setState({
            showPopover         : false,
            subItemSelectedId   : subItemSelectedId
        }, ()=>{
            this.props.onSelectTab(this.props.data.id, subItemSelectedId, e)
        })
    }

    renderOptionItems = () => {
        return _.map(this.props.data.subItems, (i,key)=>{

            const selected = this.state.subItemSelectedId ? this.state.subItemSelectedId === i.id : i.id === null;
            const classes = Classes("row", {
                selected: selected
            })

            return (
                <div key            = {key+"_"+i.id}
                     className      = {classes}
                     onMouseEnter   = {(e: React.MouseEvent)=>{this.handleHoverOn(i.info)}}
                     onMouseLeave   = {this.handleHoverOff}
                     onClick        = {(e: React.MouseEvent)=>{this.onOptionClick(i.id, e)}}>
                    <div className="label">{i.label}</div>
                </div>
            )
        })
    }

    renderPopover() {
        const { data } = this.props;
        const { showPopover, subItemSelectedId } = this.state;
        if ( showPopover ) {

            const option = _.find(data.subItems, i=>i.id === subItemSelectedId);

            const popoverPosition = new PopoverPosition({
                attachment      : "top center",
                targetAttachment: "bottom center",
                attachmentType  : PopoverAttachmentType.HORIZONTAL,
            })

            return (
                <Popover className          = "gd-tabs-selector-options-container"
                         popoverClass       = "gd-tabs-selector-options-popover"
                         targetClass        = "gd-tabs-selector-options-button"
                         position           = {popoverPosition}
                         onClickOutside     = {()=>{this.hidePopover()}}
                         getTargetFunc      = {() => findDOMNode(this)}>

                    <VScroll className="options-block"
                             scrollVisibility="auto">
                        {this.renderOptionItems()}
                    </VScroll>

                    <OptionInfo ref={this.refOptionInfo} defaultMessage={option ? option.info : null}/>

                </Popover>
            )
        } else {
            return null
        }
    }

    render() {
        const classes = Classes('option-tab', this.props.className, {
            selected: this.props.selected
        })

        const option = _.find(this.props.data.subItems, i=>i.id === this.state.subItemSelectedId)

        const styles: any = {};
        if (this.props.data.width) {
            styles.width = this.props.data.width + (option ? option.width : 0)
        }

        const subSelectionLabel = option ? <div className="option-sub-item">{option.label}</div> : null

        return (
            <div className={classes}
                 style={styles}
                 onClick={this.onSelectTab}>
                {this.props.selectionIcon && <div className="selection-icon"/>}
                {this.props.data.icon !== undefined && <div className={Classes("option-icon", this.props.data.icon)}> </div>}
                {this.props.data.title !== undefined &&
                <div className={Classes("option-text", {"has-icon": this.props.data.icon, "align-left": subSelectionLabel})}>
                    {this.props.data.title}{subSelectionLabel ? ":" : null}{subSelectionLabel}
                </div>}
                {this.props.data.count !== undefined && <div className="option-count">{this.props.data.count}</div>}

                {this.renderPopover()}

                <HintPopover hint={this.props.data.hint} showDelay={500}/>
            </div>
        );
    }
}
